import { Box, Heading } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { PieChartPercentComponent } from "../charts/PieChartComponent";
import apiService from "../../services/ApiService";

// สีของแต่ละเขต
const COLORS = [
  "#FF6F61", "#FFA07A", "#FFD700", "#32CD32", "#4682B4",
  "#9932CC", "#FF69B4", "#20B2AA", "#FF4500"
];

// รายชื่อเขต (ย่อให้เหลือแค่ "เขต" และตัวเลข)
const REGIONS = [
  "เขต 1", "เขต 2", "เขต 3", "เขต 4", "เขต 5",
  "เขต 6", "เขต 7", "เขต 8", "เขต 9"
];

// ธีมสีตามประเภทปศุสัตว์
const getTheme = (type) => {
  switch (type) {
    case "โคนม":
      return "blue";
    case "เป็ด":
      return "magenta";
    case "ไก่":
      return "orange";
    case "สุกร":
      return "purple";
    case "กระบือ":
      return "teal";
    case "โคเนื้อ":
      return "red";
    default:
      return "gray";
  }
};

export function LivestockAmountPieChart({ livestockType, sessionId }) {
  const [data, setData] = useState([]);
  const [recordYear, setRecordYear] = useState("");

  // ฟังก์ชันแปลงข้อมูลจาก API
  const processApiData = (apiData) => {
    const summary = apiData.summary || [];
    const total = summary.reduce((sum, item) => sum + item.Quantity, 0);
    
    const chartData = REGIONS.map((region, index) => {
      // แปลง DLDRegion จาก "สำนักงานปศุสัตว์เขต X" เป็น "เขต X"
      const fullRegion = `สำนักงานปศุสัตว์${region}`;
      const regionData = summary.find((item) => item.DLDRegion === fullRegion) || { Quantity: 0 };
      const quantity = regionData.Quantity || 0;
      return {
        name: region, // ใช้ "เขต X" แทนชื่อเต็ม
        value: quantity,
        percentage: total > 0 ? ((quantity / total) * 100).toFixed(2) : "0.00"
      };
    }).filter(item => item.value > 0); // กรองเฉพาะเขตที่มีข้อมูล

    return chartData;
  };

  // โหลดข้อมูลจาก API เมื่อเปลี่ยน livestockType หรือ sessionId
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiService({
          method: "POST",
          url: "/getLivestockAmountSummaryByDLDRegion",
          data: { LivestockType: livestockType },
          sessionId: sessionId || "",
        });
        if (response.result === "success") {
          setData(processApiData(response));
          setRecordYear(response.RecordYear || "ไม่ระบุ");
        } else {
          setData([]);
          setRecordYear("");
        }
      } catch (error) {
        console.error("Error fetching livestock data:", error);
        setData([]);
        setRecordYear("");
      }
    };

    fetchData();
  }, [livestockType, sessionId]);

  return (
    <Box w="100%" m={5}>
      <Heading size="md" mb={4} color="#808080">
        สัดส่วน{livestockType || "ไม่ระบุ"} แยกตามปศุสัตว์เขต ประจำปี {recordYear}
      </Heading>
      <PieChartPercentComponent
        data={data}
        theme={getTheme(livestockType)}
        width={500}
        height={300}
      />
    </Box>
  );
}